/** venture/Step13Vics.tsx — 13단계 「VICS 투자실적 보고」 (2026-09-24 · 투자확인서 발급 전 별도 단계)
 *  조합이 인수한 전환사채를 VICS에 등록한다: 법인마다 [1313 투자기업 등록] → [1319 투자유형] → [1320 투자거래],
 *  모든 법인이 끝나면 조합 단위로 [1329 보고 검증 및 확정] 한 번. 값·첨부는 VicsPanel(등록정보·8/9/12단계·업체DB 자동). */
import React, { useState } from 'react';
import CoStatBar from './CoStatBar';
import VicsPanel from './VicsPanel';
import VicsFundConfirm from './VicsFundConfirm';
import { coStat } from './costep';
import { fpLabel, regCoOf } from './coterms';
import { useTmCompanies } from './kithooks';
import { vicsDoneCount, VICS_CO_STAGES } from './vics13';
import type { Project, CoCard } from './types';

interface Props { p: Project; onPatch: (patch: Partial<Project>) => void; toast: (m: string) => void; }

function colCls(cnt: number): string { return cnt >= 3 ? 'cols3' : (cnt === 2 ? 'cols2' : 'cols1'); }

export default function Step13Vics({ p, onPatch, toast }: Props) {
  const cos: CoCard[] = (p.collect && p.collect.cos) || [];
  const [openCo, setOpenCo] = useState<Record<string, boolean>>({});
  const foldOf = (id: string): boolean => coStat(p, id, 13) === 'done' && !openCo[id];
  const toggleFold = (id: string) => setOpenCo((o) => ({ ...o, [id]: !o[id] }));
  useTmCompanies(p, onPatch);   // 업체DB(법인등록번호·주소·업종·설립일·담당자) 스냅샷 — 1313 자동 채움

  if (!cos.length) return <div className="sact"><div className="sact-h">🗂 VICS 투자실적 보고</div><div className="lbl" style={{ padding: '14px 0', textAlign: 'center' }}>등록된 투자법인이 없습니다</div></div>;

  return (
    <div className="sact">
      <div className="sact-h">🗂 VICS 투자실적 보고</div>
      <div className="lbl">조합이 인수한 전환사채를 VICS에 등록합니다 · 법인마다 1313 → 1319 → 1320 을 입력하고, 모두 끝나면 아래에서 조합 단위로 [1329] 확정/전송 한 번</div>
      <div className={'cogrid ' + colCls(cos.length)}>
        {cos.map((co) => {
          const fp = fpLabel(regCoOf(p, co));
          const n = vicsDoneCount(p, co.id);
          return (
            <div className={'cocol' + (foldOf(co.id) ? ' folded' : '')} key={co.id} id={'co-' + co.id + '-13'}>
              <div className="cocol-h">🏢 {co.name || '(법인)'}{fp ? <span className="s2tag" style={{ marginLeft: 8 }}>FP {fp}</span> : null}
                <span className={'pill ' + (n === VICS_CO_STAGES.length ? 'p-green' : n ? 'p-amber' : 'p-gray')} style={{ marginLeft: 8 }}>{n}/{VICS_CO_STAGES.length} 화면</span></div>
              <CoStatBar p={p} co={co} n={13} onPatch={onPatch} toast={toast} folded={foldOf(co.id)} onFold={() => toggleFold(co.id)} />
              {foldOf(co.id) ? null : <VicsPanel p={p} co={co} onPatch={onPatch} toast={toast} />}
            </div>
          );
        })}
      </div>
      <VicsFundConfirm p={p} cos={cos} onPatch={onPatch} toast={toast} />
    </div>
  );
}
